import { FC } from 'react';
import { ProductTable, SkuTable } from '../components/dashboard';
import { AnalyticsAll } from '../components/productGroup';

const ProductGroup: FC = () => {
  return (
    <div className="min-h-full bg-background">
      <AnalyticsAll />
      <SkuTable />
      <ProductTable />
    </div>
  );
};

export default ProductGroup;
